import { render } from "./AvatarModal.vue?vue&type=template&id=45fae32f"
import script from "./AvatarModal.vue?vue&type=script&lang=js"
export * from "./AvatarModal.vue?vue&type=script&lang=js"
script.render = render

export default script